// extracted by mini-css-extract-plugin
export var downArrow = "_8x-0";
export var infoTooltipIcon = "_8x-3";
export var label = "_8x-1";
export var optionCard = "_8x-4";
export var upArrow = "_8x-2";